export const formatPrice = (price) => {
  if (!price && price !== 0) return '0';
  return price.toLocaleString('en-IN');
};

export const calculateDiscount = (mrp, price) => {
  if (!mrp || !price) return 0;
  return Math.round(((mrp - price) / mrp) * 100);
};

export const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};
